import { Monitor, Smartphone } from "lucide-react";
import { cn } from "../../lib/utils";

interface DesktopOnlyNoticeProps {
  minimumWidth?: number;
  className?: string;
}

export function DesktopOnlyNotice({
  minimumWidth,
  className,
}: DesktopOnlyNoticeProps) {
  const belowMinimum = minimumWidth !== undefined;
  const Icon = belowMinimum ? Smartphone : Monitor;

  return (
    <section
      role="note"
      className={cn(
        "rounded-lg border border-border bg-bg p-4 text-fg",
        className
      )}
    >
      <div className="flex items-start gap-3">
        <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent/10 text-accent">
          <Icon aria-hidden="true" className="h-5 w-5" />
        </span>
        <div className="min-w-0">
          <h1 className="text-base font-semibold leading-6">
            {belowMinimum
              ? `This screen needs at least ${minimumWidth}px`
              : "Continue this workflow on a desktop"}
          </h1>
          <p className="mt-1 text-sm leading-5 text-muted">
            {belowMinimum
              ? "Cascena supports portrait phones from 360 CSS pixels wide."
              : "This route is outside the read-only mobile scope. Your desktop permissions and workflow are unchanged."}
          </p>
        </div>
      </div>
    </section>
  );
}
